import { render, staticRenderFns } from "./Offcanvas.vue?vue&type=template&id=17045839&scoped=true&"
import script from "./Offcanvas.vue?vue&type=script&lang=js&"
export * from "./Offcanvas.vue?vue&type=script&lang=js&"
import style0 from "./Offcanvas.vue?vue&type=style&index=0&id=17045839&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17045839",
  null
  
)

export default component.exports